import React from 'react';
import { Container } from '@uds/grid';
import Background, { BackgroundArray } from 'components/common/Background';
import { Colorway } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';

import Body, { OuterProps as BodyProps } from '../Body';
import Scroll from '../Scroll';
import useStylesheet from './Duo.stylesheet';

interface OuterProps extends BodyProps {
  layout: Layout;
  colorway: Colorway;
  hBaseline?: number;
  showScroll: boolean;
  duoLayout: boolean;
  background: BackgroundArray;
  onScrollClick: (evt: any) => any;
  hideGradient?: boolean;
}

export const PureBillboardDuo = ({
  layout,
  colorway,
  hBaseline = 1,
  ctas,
  text,
  additionalText,
  footerText,
  onScrollClick,
  showScroll,
  ribbonId,
  background,
  duoLayout,
  hideGradient,
}: OuterProps) => {
  const { styles } = useStylesheet({
    layout,
    duoLayout,
  });
  return (
    <>
      <Background
        background={background}
        layout={layout}
        colorway={colorway}
        hideGradient={hideGradient}
        duoLayout={true}
      />
      <div style={styles.content}>
        <div style={styles.duoLayout}>
          <Body
            colorway={colorway}
            ribbonId={ribbonId}
            text={text}
            footerText={footerText}
            additionalText={additionalText}
            ctas={ctas}
            layout={layout}
            hBaseline={hBaseline}
          />
        </div>
      </div>
      {showScroll && (
        <Container>
          <div style={styles.duoLayout}>
            <Scroll onScrollClick={onScrollClick} layout={layout} />
          </div>
        </Container>
      )}
    </>
  );
};

PureBillboardDuo.displayName = 'BillboardDuo';

export default PureBillboardDuo;
